import React from "react";

function Ticket() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M0 11.25C0 9.17893 1.67893 7.5 3.75 7.5H36.25C38.3211 7.5 40 9.17893 40 11.25V15C40 15.6904 39.4404 16.25 38.75 16.25C36.6789 16.25 35 17.9289 35 20C35 22.0711 36.6789 23.75 38.75 23.75C39.4404 23.75 40 24.3096 40 25V28.75C40 30.8211 38.3211 32.5 36.25 32.5H3.75C1.67893 32.5 0 30.8211 0 28.75V25C0 24.3096 0.559644 23.75 1.25 23.75C3.32107 23.75 5 22.0711 5 20C5 17.9289 3.32107 16.25 1.25 16.25C0.559644 16.25 0 15.6904 0 15V11.25ZM10 8.75V11.25H12.5V8.75H10ZM12.5 16.25V13.75H10V16.25H12.5ZM30 16.25V13.75H27.5V16.25H30ZM27.5 11.25H30V8.75H27.5V11.25ZM12.5 18.75H10V21.25H12.5V18.75ZM30 21.25V18.75H27.5V21.25H30ZM12.5 23.75H10V26.25H12.5V23.75ZM30 26.25V23.75H27.5V26.25H30ZM10 28.75V31.25H12.5V28.75H10ZM27.5 31.25H30V28.75H27.5V31.25Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Ticket;
